var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHouseLine = function SvgIconHouseLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.82 2.72a1.75 1.75 0 0 1 2.36 0l.001.002 7.498 6.813.014.013a1.78 1.78 0 0 1 .557 1.264v8.438h1.25a1 1 0 1 1 0 2h-21a1 1 0 1 1 0-2h1.25v-8.42zm-.07 16.53h2.5v-4h-2.5zm4.5 0V15a1.75 1.75 0 0 0-1.75-1.75h-3A1.75 1.75 0 0 0 8.75 15v4.25h-4v-8.311L12 4.35l7.25 6.588v8.311z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHouseLine;